import styled from 'styled-components';

const Container = styled.div<{
  maxWidth: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fixed?: boolean;
}>`
  width: 100%;
  box-sizing: border-box;
  padding-right: 8px;
  padding-left: 8px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.values['sm']}) {
    padding-right: 12px;
    padding-left: 12px;
  }

  ${({ theme, maxWidth }) =>
    maxWidth === 'xs'
      ? `
      @media (min-width: ${theme.breakpoints.values[maxWidth]}) {
        max-width: ${Math.max(
          Number(theme.breakpoints.values[maxWidth].slice(-2)),
          444,
        )};
      }
    `
      : `
      @media (min-width: ${theme.breakpoints.values[maxWidth]}) {
        max-width: ${theme.breakpoints.values[maxWidth]};
      }
    `}

  ${({ theme, fixed }) =>
    fixed
      ? theme.breakpoints.keys.reduce((acc: any, key: string) => {
          const value = Number(theme.breakpoints.values[key].slice(-2));

          if (value !== 0) {
            return (
              acc +
              `
                @media (min-width: ${theme.breakpoints.values[key]}) {
                  max-width: ${theme.breakpoints.values[key]};
                }\n\n
              `
            );
          }
          return '';
        }, '')
      : ''}
`;

export default Container;
